import { apiService } from './apiService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api';
const API_URL = API_BASE_URL + '/token/';
const REFRESH_URL = API_BASE_URL + '/token/refresh/';

export interface UserClinic {
  id: number;
  name: string;
}

export interface AssignedProfessional {
  id: number;
  name: string;
  email: string;
  role: string;
}

export interface User {
  id: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  clinic?: UserClinic | null;
  assignedProfessional?: AssignedProfessional | null;
}

export const authService = {
  login: async (email: string, password: string) => {
    const data = await apiService.post(API_URL, {
      username: email,
      password,
    });
    return {
      access: data.access,
      refresh: data.refresh,
      user: data.user,
    };
  },

  // Exchange the refresh token for a fresh access token (SimpleJWT TokenRefreshView).
  refresh: async (refreshToken: string): Promise<{ access: string }> => {
    const data = await apiService.post(REFRESH_URL, { refresh: refreshToken });
    return { access: data.access };
  },
}; 